/* @flow */

import { compose } from 'ramda';
import { intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  getEventProfilePositionLabel,
  getEventProfilePositionPlaceholder,
  getEventProfileCompanyLabel,
  getEventProfileCompanyPlaceholder,
} from '@e180/domain/lib/event/util';

import UserBaseFieldsetDumb from './UserBaseFieldsetDumb';
import {
  getSignupI18nFields,
  getSignupExtraFields,
} from 'plugin/signup/util/signupUtils';
import withFeatureDecisions from 'src/shared/app/feature/component/withFeatureDecisions';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';

import type { State } from 'src/shared/core/type/reduxTypes';

type Props = {
  // Self passed
  // $FlowIssue
  intl: intlShape,
  featureDecisions: Object,
  includeSignupExtraFields: ?boolean,
};

const mapStateToProps = (
  state: State,
  { intl, featureDecisions, includeSignupExtraFields }: Props,
): Object => {
  const { locale } = intl;
  const event = getEventSafely(state);

  return {
    positionLabel: getEventProfilePositionLabel(event, locale),
    positionPlaceholder: getEventProfilePositionPlaceholder(event, locale),
    companyLabel: getEventProfileCompanyLabel(event, locale),
    companyPlaceholder: getEventProfileCompanyPlaceholder(event, locale),
    i18nFields:
      includeSignupExtraFields && featureDecisions.isSignupEnabled()
        ? getSignupI18nFields(event)
        : null,
    extraFields:
      includeSignupExtraFields && featureDecisions.isSignupEnabled()
        ? getSignupExtraFields(event)
        : null,
  };
};

export default compose(
  injectIntl,
  withFeatureDecisions,
  connect(mapStateToProps),
)(UserBaseFieldsetDumb);
